import { render, staticRenderFns } from "./LedgerEntry.vue?vue&type=template&id=28075cc8&"
import script from "./LedgerEntry.vue?vue&type=script&lang=js&"
export * from "./LedgerEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports